<script setup lang="ts">
import type { IconComponent } from '@/modules/common/types/icon.type.ts';
import UiTile from '@/modules/ui/components/ui/UiTile.vue';

export type TileListType = 'buttons' | 'checkbox';

export type TileListOption = {
  code: string | number;
  label: string;
  icon: IconComponent;
  inline?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

export type TileOption = TileListOption;

const model = defineModel<{ [key: string]: boolean }>();

const {
  type = 'buttons',
  align = 'center',
  itemSize = 'default',
} = defineProps<{
  type?: TileListType;
  align?: 'center' | 'start';
  itemSize?: 'default' | 's';
  options: TileListOption[];
}>();

function onClick(option: TileListOption) {
  if (type === 'buttons') {
    option.onClick?.();
  } else {
    model.value = {
      ...model.value,
      [option.code]: !model.value?.[option.code],
    };
  }
}
</script>

<template>
  <ul
    class="ui-tile-list"
    :class="[`_align-${align}`, `_item-${itemSize}`]"
  >
    <UiTile
      v-for="option in options"
      :key="option.code"
      tag="li"
      :label="option.label"
      :icon="option.icon"
      :inline="option.inline"
      :checked="model?.[option.code]"
      :disabled="option.disabled"
      @click="onClick(option)"
    />
  </ul>
</template>

<style scoped lang="scss">
.ui-tile-list {
  display: flex;
  margin: 0 -8px -8px 0;
  flex-wrap: wrap;
  justify-content: center;

  &._align-start {
    justify-content: flex-start;
  }

  &._item-s {
    .ui-tile {
      width: 140px;
      flex: 0 0 140px;
    }
  }
}

.ui-tile {
  flex: 0 0 calc(#{100% / 3} - 8px);
  margin: 0 8px 8px 0;

  &._inline {
    flex: 0 0 calc(#{100% / 2} - 8px);
  }
}
</style>
